export default __webpack_public_path__ + "static/media/4.5ddb5b9e.png";